import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Page from "../../components/DefaultPage/DefaultPage";
import LoadingPage from "../LoadingPage/LoadingPage";
import classes from "./PrizeStats.module.css";
// import MaterialIcon from "react-google-material-icons";
import { FaSearch } from "react-icons/fa";

function PrizeStats() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadedPrizes, setLoadedPrizes] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("");
  const { t } = useTranslation("global");
  
  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const serverPath = protocol + "://" + ip + ":" + port;
  const allPrizesPath = serverPath + "/all-prizes";

  useEffect(() => {
    setIsLoading(true);
    fetch(allPrizesPath)
      .then((response) => response.json())
      .then((prizes) => {
        setLoadedPrizes(Object.values(prizes));
        setIsLoading(false);
      });
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };

  const filteredPrizes = loadedPrizes.filter((prize) =>
    prize.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortPrizes = (a, b) => {
    if (sortOption === "dueDate" || sortOption === "quantity" || sortOption === "pointValue") {
      return new Date(b[sortOption]) - new Date(a[sortOption]);
    } else if (sortOption === "maxPerUser") {
      return a[sortOption] - b[sortOption];
    } else {
      return 0;
    }
  };

  const sortedPrizes = filteredPrizes.sort(sortPrizes);

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <Page>
      <div className={classes.controls} style={{ marginTop: "5rem" }}>
      <h1>{t("stats.titles.prizeOverview")}</h1>
      <div style={{display: "flex", justifyContent: "left", alignItems: "center"}}>
          {/* <MaterialIcon
            className="search-icon"
            icon="search"
            size={24}
            color="rgba(0, 0, 0, 0.54)"
          /> */}
          
          <input
  className={classes.searchbar}
  type="text"
  placeholder={t("sorter.searchBar.placeholder")}
  value={searchQuery}
  onChange={handleSearchChange}
  style={{
    background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23000000" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>') no-repeat 5px center`,
    paddingLeft: "30px", // Adjust padding to fit the icon
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "16px", // Adjust font size to fit the icon
    lineHeight: "1.5",
    border: "2px solid #067451",
    borderRadius: "4px",
    boxSizing: "border-box",
    width: "100%",
    height: "36px",
    outline: "none"
  }}
/>

        <select value={sortOption} onChange={handleSortChange}>
          <option value="" disabled hidden>{t("sorter.selectButtonLabels.sortBy")}</option>
          <option value="dueDate">{t("sorter.selectButtonLabels.dueDate")}</option>
          <option value="quantity">{t("sorter.selectButtonLabels.quantity")}</option>
          <option value="pointValue">{t("sorter.selectButtonLabels.pointValue")}</option>
          <option value="maxPerUser">{t("sorter.selectButtonLabels.maxPerUser")}</option>
        </select>
        </div>
      </div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>{t("stats.columns.title")}</th>
            <th>{t("stats.columns.description")}</th>
            <th>{t("stats.columns.maxPerUser")}</th> 
            <th>{t("stats.columns.quantity")}</th>
            <th>{t("stats.columns.pointValue")}</th>
            <th>{t("stats.columns.dueDate")}</th>
            <th>{t("stats.columns.creationDate")}</th>
          </tr>
        </thead>
        <tbody>
  {sortedPrizes.map((prize, index) => (
    <React.Fragment key={index}>
      <tr>
        <td>{prize.title}</td>
        <td>{prize.description}</td>
        <td>{prize.maxPerUser}</td>
        <td>{prize.quantity}</td>
        <td>{prize.pointValue}</td>
        <td>{prize.dueDate}</td>
        <td>{prize.creationDate}</td>
      </tr>
      {index !== sortedPrizes.length - 1 && <tr><td colSpan="7"><hr /></td></tr>}
    </React.Fragment>
  ))}
</tbody>

      </table>
    </Page>
  );
}

export default PrizeStats;
